import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { validateZero } from '../../../../core/validators/validators';
import { LoadingSpaceType } from '../../../../core/types';
import { Subscription } from 'rxjs';

interface StackingForm extends UntypedFormGroup {
  value: {
    palletStacking: boolean;
    palletFloorNumber: number;
    palletFloorWeight: boolean;
    palletMaxWeight: number;
  };
}

@Component({
    selector: 'gl-loading-space-pallet-stacking',
    templateUrl: './loading-space-pallet-stacking.component.html',
    styleUrls: ['./loading-space-pallet-stacking.component.scss'],
    standalone: false
})
export class LoadingSpacePalletStackingComponent implements OnChanges, OnInit, OnDestroy {
  @Input() public isEdit = false;
  @Input() public loadingSpace: LoadingSpaceType;
  @Output() public submitEvent = new EventEmitter();
  @Input() public chosenLoadingSpace: LoadingSpaceType;
  public form: StackingForm;
  private formSubscription: Subscription;

  constructor() {
    this.form = this.generateStackingForm();
  }

  private generateStackingForm(): StackingForm {
    return new UntypedFormGroup({
      palletStacking: new UntypedFormControl(null),
      palletFloorNumber: new UntypedFormControl(null, [validateZero]),
      palletFloorWeight: new UntypedFormControl(null),
      palletMaxWeight: new UntypedFormControl(null, [validateZero]),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.isEdit && changes.isEdit.currentValue) {
      this.form.enable();
    }
    if (changes && changes.isEdit && !changes.isEdit.currentValue) {
      this.form.disable();
    }

    if (changes.chosenLoadingSpace && changes.chosenLoadingSpace.currentValue) {
      const palletStacking = changes.chosenLoadingSpace.currentValue.palletStacking as boolean;
      const palletFloorNumber = changes.chosenLoadingSpace.currentValue.palletFloorNumber as number;
      const palletFloorWeight = changes.chosenLoadingSpace.currentValue.palletFloorWeight as boolean;
      const palletMaxWeight = changes.chosenLoadingSpace.currentValue.palletMaxWeight as number;
      this.form.patchValue({
        palletStacking: palletStacking !== undefined ? palletStacking : null,
        palletFloorNumber: palletFloorNumber  !== undefined ?  palletFloorNumber : null,
        palletFloorWeight: palletFloorWeight  !== undefined ?  palletFloorWeight : null,
        palletMaxWeight: palletMaxWeight  !== undefined ? palletMaxWeight : null,
      });
    }
  }

  ngOnInit(): void {
    this.formSubscription = this.form.valueChanges.subscribe(() => {
      this.submitEvent.emit(this.form.value);
    });
    const palletStacking = this.loadingSpace.palletStacking;
    const palletFloorNumber = this.loadingSpace.palletFloorNumber;
    const palletFloorWeight = this.loadingSpace.palletFloorWeight;
    const palletMaxWeight = this.loadingSpace.palletMaxWeight;
    this.form.patchValue({
      palletStacking: palletStacking !== undefined ? palletStacking : null,
      palletFloorNumber: palletFloorNumber  !== undefined ?  palletFloorNumber : null,
      palletFloorWeight: palletFloorWeight  !== undefined ?  palletFloorWeight : null,
      palletMaxWeight: palletMaxWeight  !== undefined ? palletMaxWeight : null,
    });
  }

  ngOnDestroy(): void {
    this.submitEvent.emit(this.form.value);
    this.formSubscription.unsubscribe();
  }
}
